// extracted by mini-css-extract-plugin
export default {"disclaimer":"cyJdb6"};